<template>
	<div>
	<div height=56 class="titleBlock" >

			<v-layout row justify-space-between style="z-index: 100; position: fixed; width: 100%">
		  		<v-flex >
		  			<!-- <span class="px-4 body-1">Mapping...</span> -->
		  			<!-- <v-progress-linear style="position: relative; top: 20px;" color="grey" :indeterminate="true"></v-progress-linear>	 -->	        
		    	</v-flex>
		  	</v-layout>		
	</div>
	<v-layout v-if="!showMap" fill-height align-center justify-center class="darkOverlay">
    	<v-progress-circular color="white" style="position: relative; top:0px;"
    		size="150" width="20" indeterminate>
   		</v-progress-circular>
   		<span class="title animated6 fadeOut mt-5">Loading...</span>
   		<!-- <span class="subheading animated10 fadeIn">Aligning Covariance Matrices...</span> -->
	</v-layout>
	</div>
</template>

<script>

import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {

	computed: {
		...mapState({	selectedBuilding: state => state.space.selectedBuilding,
						selectedRoom: state => state.space.selectedRoom,
						mapReady: state => state.ui.mapReady,
						showMap: state => state.ui.showMap,
					}),
	},


	methods: {
		...mapMutations(['setSelectedRoom', 'setShowToolbar', 'setSelectedBuilding', ]),
		...mapActions(['clearGraphics']),
	}
}

</script>

<style>

.darkOverlay {
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 2;
    position: fixed;
    top: 0;
    width: 100vw;
    background-color: rgba(188, 188, 188, 1);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
    padding-top: 10px;
    margin-top: 0px;
    height: 100%;
}

.animated6 {
            -webkit-animation-duration: 1s;animation-duration: 6s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }

.animated10 {
            -webkit-animation-duration: 1s;animation-duration: 10s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }

.animated8 {
            -webkit-animation-duration: 1s;animation-duration: 8s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }
         
         @-webkit-keyframes fadeOut {
            0% {opacity: 1;}
            100% {opacity: 0;}
         }
         
         @keyframes fadeOut {
            0% {opacity: 1;}
            100% {opacity: 0;}
         }
         
         .fadeOut {
            -webkit-animation-name: fadeOut;
            animation-name: fadeOut;
         }

         @-webkit-keyframes fadeIn {
            0% {opacity: 0;}
            100% {opacity: 1;}
         }
         
         @keyframes fadeIn {
            0% {opacity: 0;}
            100% {opacity: 1;}
         }
         
         .fadeIn {
            -webkit-animation-name: fadeIn;
            animation-name: fadeIn;
         }
</style>
